.hint {
  margin: 10px 0 25px;
  font-size: 16px;
  font-weight: 300;
  color: #969696;
  text-align: center;
  width: 100%;
}
